import { getAssetUrl } from '../../Common/Utils/assetUrl';
export const mapB2CTenantToLanding = (tenantData) => {
  const theme = tenantData?.theme || {};
  const topBar = tenantData?.topBar || {}; 
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero = tenantData?.hero || {};

  return {
    // Identity
    isPreview: tenantData?.isPreview ?? false,
    companyId:       tenantData?.companyId,
    branchId:        tenantData?.branchId, 
    userId:          tenantData?.userId,
    logoUrl: getAssetUrl(tenantData?.branding?.logoUrl),
    companyName:     tenantData?.branding?.companyName  || 'Travel Agency',
    brandName:       tenantData?.branding?.brandName    || 'Travel Agency',
    
    // Contact
    email:           tenantData?.branding?.email        || 'travelagency@gmail.com',
    phones:          tenantData?.branding?.phones       || '9098712312',
    whatsapp:        tenantData?.branding?.whatsapp     || '9081212890',
    socials:         tenantData?.branding?.socials      || {},
    companyData:     tenantData?.companyData || {},
    seo:             tenantData?.seo || {},

    // Dynamic Static Page Contents mapped to Context
    aboutUs:         tenantData?.aboutUs || {},
    contactUs:       tenantData?.contactUs || {},
    faq:             tenantData?.faq || {},
    terms:           tenantData?.terms || {},
    privacyPolicy:   tenantData?.privacyPolicy || {},
    refundPolicy:    tenantData?.refundPolicy || {},

    // Colors
    themeColor1:     theme.themeColor1 || theme.themecolor1, 
    themeColor2:     theme.themeColor2 || theme.themecolor2,
    themeColor3:     theme.themeColor3 || theme.themecolor3,
    themeColor4:     theme.themeColor4 || theme.themecolor4,
    themeColor5:     theme.themeColor5 || theme.themecolor5,

    // Overrides
   topBarBg:        topBar.bgColor   || theme.themeColor2 || theme.themecolor2 || "#0B1F3A",
    topBarText:      topBar.textColor || "#ffffff",
    headerBg:        header.bgColor   || theme.themeColor1 || theme.themecolor1 || "#FDE176",
    headerText:      header.textColor || "#111111",
    footerBg:        footer.bgColor   || theme.themeColor2 || theme.themecolor2 || '#FDE176',
    footerText:      footer.textColor || '#000000',

    heroData: {
        flights: {
            title:    hero.flights?.title    || "Book Flights at Unbeatable Prices",
            subTitle: hero.flights?.subTitle || "Compare 300+ airlines and unlock exclusive fares — all in one search.",
            textColor: hero.flights?.textColor || "#ffffff", 
            bgImage:  hero.flights?.bgImage || "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=1920&auto=format&fit=crop"
        },
        hotels: {
            title:    hero.hotels?.title    || "Search and Book hotels.",
            subTitle: hero.hotels?.subTitle || "Best hotel deals.",
            textColor: hero.hotels?.textColor || "#ffffff", // ⭐ Fixed path
            bgImage:  hero.hotels?.bgImage  || "https://images.unsplash.com/photo-1645379033960-72d6cb488c0e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODZ8fHJlc29ydHxlbnwwfHwwfHx8MA%3D%3D"
        },
        holidays: {
            title:    hero.holidays?.title    || "Find Your Perfect Trip.",
            subTitle: hero.holidays?.subTitle || "Search deals on homes.",
            textColor: hero.holidays?.textColor || "#ffffff", // ⭐ Fixed path
            bgImage:  hero.holidays?.bgImage  || "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTV8fHJlc29ydHxlbnwwfHwwfHx8MA%3D%3D"
        },
        sightseeing: {
            title:    hero.sightseeing?.title    || "Search and Book Activities.",
            subTitle: hero.sightseeing?.subTitle || "Find the best activities.",
            textColor: hero.sightseeing?.textColor || "#ffffff", // ⭐ Fixed path
            bgImage:  hero.sightseeing?.bgImage  || "https://images.unsplash.com/photo-1533105079780-92b9be482077?q=80&w=1200"
        }
    }
  };
};

// 2. Color Resolver for B2C T2
export const getB2CColors_T1 = (landingData) => {
  const c1 = landingData.themeColor1 || "#F4B400";   // Gold Primary

  return {
    theme1: c1,                                  // Gold
    theme2: landingData.footerBg || "#0B1F3A",   // Dark Navy
    theme3: landingData.headerBg || "#ffffff",   // White Header
    theme4: landingData.themeColor4 || "#F5F7FA",
    theme5: landingData.themeColor5 || "#111111",

    headerText: landingData.headerText || "#111111",
    footerText: landingData.footerText || "#ffffff",

    topBarBg: landingData.topBarBg || "#0B1F3A",
    topBarText: landingData.topBarText || "#ffffff",
  };
};